import React from 'react';
import { useLocalStorage } from 'react-use';
import IconButton from 'components/buttons/IconButton';
import { X } from 'kzv-icons';

const ContestSearchResultsCard = () => {
    const [closedCard, setHasClosedCard] = useLocalStorage('search-contest-card-closed', false);

    if (closedCard) return null;

    return (
        <div className="rounded-3xl shadow-2xl lg:col-span-2 p-6 relative text-sm md:text-base">
            <h2 className={'text-brand max-w-md text-xl md:text-2xl'}>
                Sodeluj v nagradnem foto natečaju lepot Slovenije
            </h2>
            <ul className="list-decimal list-inside mt-4 mb-4">
                <li>
                    <strong>Poišči točke</strong>, ki so del nagradnega foto natečaja.
                </li>
                <li>
                    <strong>Pobrskaj po galeriji fotografij</strong> na svojem telefonu ali fotoaparatu.
                </li>
                <li>
                    <strong>Naloži fotografije</strong>, ki pripadajo točkam v foto natečaju.
                </li>
            </ul>
            <p>
                <strong>Tako se uvrstiš v žreb za vsestranski fotoaparat Nikon Z 30</strong>, s katerim je preprosto
                ustvarjati čudovite fotografije in video vsebine na profesionalnem nivoju. Želimo ti veliko sreče!
            </p>
            <div className="absolute top-0 right-0 lg:top-2 lg:right-4">
                <IconButton onClick={() => setHasClosedCard(true)}>
                    <X width={30} height={30} strokeWidth={2} />
                </IconButton>
            </div>
        </div>
    );
};

export default ContestSearchResultsCard;
